import { Badge, Popover } from 'antd';
import { UncontrolledTooltip } from 'reactstrap';
import { IconButton } from '@/shared/ui';
import { TYPE_BEAT_EVENT_ENUM, TYPE_RHYTHM_EVENT_ENUM } from '@/shared/config';
import { TBeatHrActiveTab } from '@/shared/model';
import filterOptionsIcon from './assets/filter-option-icon.svg';
import FilterPopover from './filterPopover';
import useFilterEvents from './useFilterEvents';
import './styles.scss';

export type FilterEventsProps = {
  setPageIndex: (page: any) => void;
  // matches activeTabState's atom type (Recoil, Task 7): callers pass its value straight through.
  activeButton: TYPE_RHYTHM_EVENT_ENUM | TYPE_BEAT_EVENT_ENUM | TBeatHrActiveTab;
  keyRecoil: string;
  isDisabled?: boolean;
};

/**
 * Filter button opening the event filter popover of an events tab. Renders a badge with the active filter count over the icon button, hosts the popover content wired to the hook's filter state and visibility flags, and shows a tooltip summarizing the active filters when at least one is set.
 *
 * @param props - The filter props, carrying keyRecoil, setPageIndex and isDisabled.
 * @returns The rendered filter button with its badge, popover and summary tooltip.
 */
const FilterEvents = ({ setPageIndex, activeButton, keyRecoil, isDisabled }: FilterEventsProps) => {
  const {
    eventFilter,
    setEventFilter,
    isOpen,
    setIsOpen,
    isShowCountBeats,
    optionrhythm,
    isShowFilterDuration,
    isShowAvgHrBelow100,
    onOpenChange,
    eventFilterInfos,
  } = useFilterEvents({ activeButton, keyRecoil });

  return (
    <div className="filter-events">
      <Popover
        open={isOpen}
        overlayClassName="filter-events-popover"
        content={
          <FilterPopover
            keyRecoil={keyRecoil}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            eventFilter={eventFilter}
            setEventFilter={setEventFilter}
            setPageIndex={setPageIndex}
            isShowCountBeats={isShowCountBeats}
            isShowFilterDuration={isShowFilterDuration}
            optionrhythm={optionrhythm}
            isShowAvgHrBelow100={isShowAvgHrBelow100}
          />
        }
        title={null}
        trigger="click"
        onOpenChange={onOpenChange}
        destroyOnHidden
      >
        <Badge count={eventFilterInfos.count} className="badge-filter">
          <IconButton
            id="filterEventBtn"
            disabled={isDisabled}
            isFilled
            iconComponent={<img src={filterOptionsIcon} alt="Filter icon" />}
            onClick={() => {}}
          />
        </Badge>
        {eventFilterInfos.count > 0 && (
          <UncontrolledTooltip
            target="filterEventBtn"
            className="custom-tooltip tooltip-filter-event"
            placement="bottom"
            delay={{ show: 0, hide: 0 }}
            hideArrow
          >
            {eventFilterInfos.textHtml}
          </UncontrolledTooltip>
        )}
      </Popover>
    </div>
  );
};

export default FilterEvents;
